var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocsHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C18.6863 4 16 6.68629 16 10V86C16 89.3137 18.6863 92 22 92H74C77.3137 92 80 89.3137 80 86V28L56 4H22Z",
    fill: "#4E8DF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92C18.6863 92 16 89.3137 16 86V85C16 88.3137 18.6863 91 22 91H74C77.3137 91 80 88.3137 80 85V86C80 89.3137 77.3137 92 74 92H22Z",
    fill: "#417EE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C18.6863 4 16 6.68629 16 10V11C16 7.68629 18.6863 5 22 5H57L56 4H22Z",
    fill: "#639AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48.5V28L76.5 24.5H59.6213C58.285 24.5 57.6157 26.1157 58.5607 27.0607L80 48.5Z",
    fill: "url(#paint0_linear_3_191)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56 4L80 28H62C58.6863 28 56 25.3137 56 22V4Z",
    fill: "#A6C5FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48H32V52H64V48Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 56H32V60H64V56Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64H64V68H32V64Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72H32V76H56V72Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_191",
    x1: 68,
    y1: 48.5,
    x2: 68,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsHome);
export default __webpack_public_path__ + "static/media/docs-home.0ee1cb60ab5ff23a5273bdecd8e213cc.svg";
export { ForwardRef as ReactComponent };